<template>
  <div id="app-root">
    <!-- Login (no chrome) -->
    <template v-if="isAuthPage">
      <router-view @executeFunction="executeFunction"></router-view>
    </template>

    <!-- Authenticated layout shell -->
    <template v-else>
      <div class="layout-container">
        <div style="z-index: 1000 !important">
          <SideNavbar ref="sideNavbar" @button-click="handleLangChange"></SideNavbar>
        </div>

        <div class="page-main-column">
          <!-- Sticky header with burger toggle + page title -->
          <header class="sticky-header">
            <div class="header-content">
              <div class="header-left-section">
                <div class="toggle-btn-container">
                  <div class="toggle-btn" :class="{ 'is-active': !isSidebarCollapsed }" @click="toggleSidebar" title="Toggle Sidebar">
                    <i class="bx bx-sidebar"></i>
                  </div>
                </div>
                <div class="page-title-container">
                  <h2 class="page-title">{{ currentPageTitle }}</h2>
                </div>
              </div>
            </div>
          </header>

          <!-- Scrollable content -->
          <main class="page-scroll-content">
            <router-view v-slot="{ Component }">
              <transition name="fade" mode="out-in">
                <component :is="Component" :key="$route.fullPath" />
              </transition>
            </router-view>
          </main>
        </div>

        <BottomFooter ref="BottomFooterRef"></BottomFooter>
      </div>
    </template>
  </div>
</template>

<script>
import SideNavbar from "./components/SideNavbar.vue";
import BottomFooter from "./components/BottomFooter.vue";

export default {
  name: "App",
  components: { SideNavbar, BottomFooter },
  data() {
    return { isSidebarCollapsed: false };
  },
  computed: {
    isAuthPage() {
      return this.$route.path === "/" || this.$route.path === "";
    },
    currentPageTitle() {
      const path = this.$route.path;
      const titleMap = {
        "/dashboard": "Dashboard",
        "/enroll": "Register User",
        "/manage-devices": "Devices",
        "/device-data-list": "Device Details",
        "/manage-accounts": "Manage Accounts",
        "/faq": "Help Center",
        "/profile": "User Profile",
        "/reporting": "Reporting",
        "/register/device": "Register Device",
        "/register/user": "Enroll User",
      };
      for (const [route, title] of Object.entries(titleMap)) {
        if (path === route || path.startsWith(route + "/")) return title;
      }
      return "Ctrlytics";
    },
  },
  watch: {
    $route() {
      this.syncSidebarState();
    },
  },
  mounted() {
    this.syncSidebarState();
  },
  methods: {
    executeFunction() {},
    syncSidebarState() {
      this.$nextTick(() => {
        if (this.$refs.sideNavbar) {
          this.isSidebarCollapsed = this.$refs.sideNavbar.isCollapsed;
        }
      });
    },
    handleLangChange(lang) {
      if (this.$refs.BottomFooterRef) this.$refs.BottomFooterRef.langchange(lang);
    },
    toggleSidebar() {
      if (this.$refs.sideNavbar) {
        this.$refs.sideNavbar.toggleSidebar();
        this.isSidebarCollapsed = this.$refs.sideNavbar.isCollapsed;
      }
    },
  },
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: var(--font-family-base);
  color: var(--text-main);
}
body { background-color: var(--background-color); }

.layout-container {
  display: flex;
  background-color: var(--background-color);
  height: 100vh;
  position: relative;
  overflow: hidden;
}

.page-main-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;
  overflow: hidden;
}

.sticky-header {
  flex-shrink: 0;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  padding: 20px 40px;
  border-bottom: 1px solid var(--border-color);
  z-index: 999;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}
.header-content { display: flex; justify-content: space-between; align-items: center; }
.header-left-section { display: flex; align-items: center; gap: 20px; }
.page-title {
  font-size: 20px; font-weight: 700; color: var(--text-main); margin: 0;
  font-family: var(--font-family-header, "Century Gothic Bold");
}
.toggle-btn {
  width: 32px; height: 32px; display: flex; align-items: center; justify-content: center;
  cursor: pointer; font-size: 26px; color: var(--text-main); transition: color 0.2s ease;
}
.toggle-btn:hover { color: var(--primary-color); }

.page-scroll-content {
  flex: 1;
  padding: 24px 40px 60px 40px;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);
  overflow-y: auto;
  position: relative;
}

.fade-enter-active, .fade-leave-active { transition: opacity 0.2s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

@media (max-width: 768px) {
  .sticky-header { padding: 16px; }
  .page-scroll-content { padding: 15px; padding-bottom: 60px; }
  .page-title { font-size: 18px; }
}
</style>
